import React, { useState } from "react";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { Card, CardContent, Button, Grid } from "@deere/fuel-react";
import { saveNewAddedSubTierSuppliers, deleteSubtierSupplierData, getSubtierSupplierData, updateCampaignStatus } from "../../services/survey.service";
import { useOktaAuth } from "@okta/okta-react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import cookie from "js-cookie";
import { CRS_REQUEST_STATUS_OBJ, NO_DATA_ERR, NON_OKTA_USER } from "../../utils/surveyLiterals";
import { setSTSupplierData } from "../../redux/action/subTierSurveyAction";
import { useUserInfo } from "../../providers/userProvider";
import { ModalSubmit } from "../../components/ModalSubmit";

const ButtonSection = (props) => {
  const dispatch = useDispatch();
  const { authState } = useOktaAuth();
  const userInfo = useUserInfo();
  const { t } = useTranslation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [currentLanguageCode, setCurrentLanguageCode] = useState(cookie.get("i18next") || "en");
  const [disableButtons, setDisableButtons] = useState(false);
  const supplierData = useSelector((state) => state.subTierSurvey.supplierData);

  const keysForSavingData = ["id", "supplierName", "streetAddress", "country", "city", "state", "postalCode", "tierLevel", "productType", "isDiverseEnterprise"];

  const changeLanguage = (locale) => {
    i18next.changeLanguage(locale);
    setCurrentLanguageCode(locale);
  };

  let isAuthMethodOkta = props.isAuthMethodOkta || props.isAuthMethodOkta === undefined ? true : false;
  let token = props.isAuthMethodOkta || props.isAuthMethodOkta ? authState.accessToken.accessToken : "";

  const saveHandler = (submit) => {
    let noDataToSave = false;
    if (submit && supplierData.length === 0) {
      props.displayErrorCard([NO_DATA_ERR]);
    } else {
      setDisableButtons(true);
      const updated = [];
      const deleted = [];
      let supplierData_deepCopy = JSON.parse(JSON.stringify(supplierData));
      supplierData_deepCopy.forEach((data) => {
        if ((data.addedByUser || data.editedByUser) && !data.deletedByUser) { //Items which are added newly or are existing but edited, but neither should have deleted flag.
          for (const key in data) if (!keysForSavingData.includes(key)) delete data[key];
          updated.push({ primarySupplierNo: props.supplierId, ...data });
        } else if (data.deletedByUser && !data.addedByUser) { // Items having deleted flag with an exeption of newly added & deleted.
          deleted.push({ primarySupplierNo: props.supplierId, id: data.id });
        }
      });
      if (updated.length > 0) {
        saveNewAddedSubTierSuppliers(updated, token, isAuthMethodOkta).then((res) => {
          if (deleted.length > 0) {
            let resCount = 0;
            deleted.forEach((d) => {
              deleteSubtierSupplierData(d, token, isAuthMethodOkta)
                .then(() => {
                  resCount++;
                  if (resCount === deleted.length){
                    setStatusToInProcess();
                    setDisableButtons(false);
                    callGETMethodToRefreshData(submit, noDataToSave);
                  }
                })
                .catch((error) => {
                  console.log(error);
                  resCount++;
                  setDisableButtons(false);
                });
            });
          } else{
            setStatusToInProcess();
            setDisableButtons(false);
            callGETMethodToRefreshData(submit, noDataToSave);
          }
        });
      } else if (deleted.length > 0) {
        let resCount = 0;
        deleted.forEach((d) => {
          deleteSubtierSupplierData(d, token, isAuthMethodOkta)
            .then(() => {
              resCount++;
              if (resCount === deleted.length){
                setStatusToInProcess();
                setDisableButtons(false);
                callGETMethodToRefreshData(submit, noDataToSave);
              }
            })
            .catch((error) => {
              console.log(error);
              resCount++;
              setDisableButtons(false);
            });
        });
      } else{
        setDisableButtons(false);
        noDataToSave = true;
        callGETMethodToRefreshData(submit, noDataToSave);
      }
    }
  };
 
    const callGETMethodToRefreshData = (submit, noDataToSave) => {
      getSubtierSupplierData(props.supplierId, token, isAuthMethodOkta).then((res) => {
        if (res) dispatch(setSTSupplierData([...res]));
        if (submit) { 
          if (res.length > 0) redirectToReview(); //Submit Button was clicked & supplier data is presen 
          else props.displayErrorCard([NO_DATA_ERR]); //Submit Button was clicked but supplier data is not present 
        } else if (!noDataToSave) props.displaySaveAlert(); //Save Button was clicked
      });
    };
  
  const redirectToReview = () => {
    let locationState = {
      previous: "/st",
      supplierName: props.supplierName,
      supplierNumber: props.supplierNo,
      endDate: props.endDate,
      rn: props.rn,
      campaign: props.campaign
    };
    if (!isAuthMethodOkta) locationState = { ...locationState, isAuthNonOkta: true };
    history.push({
      pathname: isAuthMethodOkta ? "/streview" : "/streviewext",
      state: locationState,
    });
  };

  const setStatusToInProcess = () => {
    let statusObj = { id: props.rn, status: CRS_REQUEST_STATUS_OBJ.IN_PROCESS, updatedBy: userInfo ? userInfo.userID : NON_OKTA_USER };
    updateCampaignStatus(statusObj, token, isAuthMethodOkta);
  }

  const handleSubmit = () => {
    let statusObj = { id: props.rn, status: CRS_REQUEST_STATUS_OBJ.COMPLETE, updatedBy: userInfo ? userInfo.userID : NON_OKTA_USER };
    updateCampaignStatus(statusObj, token, isAuthMethodOkta).then(() => {
      window.scrollTo(0, 0);
      setShowModal(true);
    });
  };

  if (props.biRef) props.biRef.saveFunction = saveHandler;

  return (
    <Card borderRadius="none">
      <CardContent>
        <Grid container justifyContent="flex-end">
          {props.showActions ? (
            <>
              <Button variant="secondary" sx={{ marginRight: "10px" }} onClick={() => saveHandler(false)} disabled={disableButtons}>
                {t("btn_save_survey")}
              </Button>
              <Button variant="primary" type="submit" disabled={props.isAdmin || disableButtons}>
                {t("btn_review")}
              </Button>
            </>
          ) : (
            <>
              <Button variant="secondary" sx={{ marginRight: "10px" }} onClick={(e) => history.goBack()} disabled={props.prev === "/" || props.prev === "/details"}>
                Back to Edit
              </Button>
              <Button variant="primary" onClick={handleSubmit} disabled={props.prev === "/" || props.prev === "/details"}>
                Submit
              </Button>
            </>
          )}
        </Grid>
      </CardContent>
      <ModalSubmit showModal={showModal} setShowModal={setShowModal} titleKey={"survey_submit_modal_title"} messageKey={"submit_popup_message"} doNotNavidate={!isAuthMethodOkta} />
    </Card>
  );
};

export default ButtonSection;
